import { useEffect, useState } from "react";
import { useRuntimeConstants } from "../context/runtimeConstants/RuntimeConstantsContext";
import { useFeaturesReady } from "../context/featuresReady/FeaturesReadyContext";
import { getFeature } from "../utils/features";
import { getLoyaltySDK } from "../api/loyaltySdk";
import {
  FEATURE_FLAGS,
  NEW_IN_CATEGORY_IDS,
  LOYALTY_CONSENT_STATUS,
} from "../constants";

export const useNewInBoxConditions = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const { referrerData } = useRuntimeConstants();
  const { areFeaturesReady } = useFeaturesReady();

  const cid = referrerData?.cid;
  const isFromNewInPage = [
    NEW_IN_CATEGORY_IDS.WOMEN,
    NEW_IN_CATEGORY_IDS.MEN,
  ].includes(cid);

  useEffect(() => {
    if (!areFeaturesReady) {
      return;
    }

    if (!isFromNewInPage) {
      setShouldShow(false);
      return;
    }

    const checkEligibilityAndExperiment = async () => {
      try {
        const loyaltySdk = await getLoyaltySDK();

        if (!loyaltySdk.isLoyaltyAvailable()) {
          setShouldShow(false);
          return;
        }

        let isEligible = true;

        if (loyaltySdk.getCustomerDetails) {
          const customerDetails = await loyaltySdk.getCustomerDetails();

          isEligible =
            customerDetails?.consentStatus !== LOYALTY_CONSENT_STATUS.OPTED_IN;
        }

        if (!isEligible) {
          setShouldShow(false);
          return;
        }

        const isExperimentEnabled = getFeature(
          FEATURE_FLAGS.LOYALTY_NEW_IN_TODAY_LOCK_PRODUCT
        ).isEnabled();

        setShouldShow(!!isExperimentEnabled);
      } catch {
        setShouldShow(false);
      }
    };

    checkEligibilityAndExperiment();
  }, [areFeaturesReady, isFromNewInPage]);

  return shouldShow;
};
